import React from 'react';
import classnames from 'classnames';
import PromptBox from 'ui/components/common/dumb/PromptBox';
import UserForm from 'ui/components/common/smart/UserForm/UserForm';
import UseFacebook from 'ui/components/common/smart/UseFacebook';
import LoginRegisterSwitch from 'ui/components/common/smart/LoginRegisterSwitch';
import * as styles from './LoginForm.module.scss';
import { useTranslation } from 'react-i18next';
import inMainScreen from 'ui/components/hocs/inMainScreen';
import { HOUR_OF_CODE_TOKEN_STORAGE_KEY } from 'ui/constants';
import useLocalStorage from '@rehooks/local-storage';
import { Navigate } from 'react-router-dom';

const LoginForm: React.FC = () => {
  const { t } = useTranslation('userForm');
  const [contestToken] = useLocalStorage<boolean>(HOUR_OF_CODE_TOKEN_STORAGE_KEY);

  if (contestToken === true) {
    return <Navigate to="/" />;
  }

  return (
    <PromptBox className={styles.promptBox}>
      <PromptBox.Row>
        <PromptBox.Heading>{t('loginHeading')}</PromptBox.Heading>
        <UserForm mode="login" />
      </PromptBox.Row>
      <PromptBox.Row className={styles.row}>
        <UseFacebook mode="login" />
      </PromptBox.Row>
      <PromptBox.Row className={classnames(styles.pad, styles.row)}>
        <LoginRegisterSwitch mode="login" />
      </PromptBox.Row>
    </PromptBox>
  );
};

export default inMainScreen(LoginForm);
